export default "__VITE_ASSET__766dd059__"